export const Loading = () => (
  <div className='container-fluid base-content flex-fill d-flex justify-content-center align-items-center'>
    <span className='fas fa-spinner fa-spin fa-3x' />
  </div>
);
